import { useState, useEffect } from "react";
import { NavLink, Link, useLocation } from "react-router-dom";
import { useAuth } from "../../lib/useAuth";
import { useClientProjects } from "../../lib/useClientProjects";
import Logo from "../ui/Logo.jsx";
import styles from "./Navbar.module.css";

const navClass = ({ isActive }) =>
  `${styles.link} ${isActive ? styles.linkActive : ""}`;

export default function Navbar() {
  const { user, isAdmin, isClient, signOut, client } = useAuth();
  const email = client?.email || user?.email || "";
  const { items } = useClientProjects(email);
  const clientLogo = items?.[0]?.clientLogo;

  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  // cerrar el menú móvil al cambiar de ruta
  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  // Todo el sitio público usa el tema grafito; solo la portada superpone el nav sobre la escena 3D
  const isHome = pathname === "/";

  return (
    <header
      className={styles.nav}
      data-open={open}
      data-dark="true"
      data-overlay={isHome}
    >
      <Link to="/" className={styles.brand} aria-label="Aya Technologies — inicio">
        {clientLogo && (
          <>
            <img src={clientLogo} alt="Client Logo" className={styles.clientLogo} />
            <span className={styles.sep}>|</span>
          </>
        )}
        <Logo size={132} />
      </Link>

      <button
        type="button"
        className={styles.burger}
        aria-label={open ? "Cerrar menú" : "Abrir menú"}
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
      >
        <span />
        <span />
        <span />
      </button>

      <div className={styles.menu}>
        <nav className={styles.links} aria-label="Navegación principal">
          <NavLink to="/" end className={navClass}>
            Inicio
          </NavLink>
          <NavLink to="/proyectos" className={navClass}>
            Proyectos
          </NavLink>
          <NavLink to="/servicios" className={navClass}>
            Servicios
          </NavLink>
          <NavLink to="/nosotros" className={navClass}>
            Nosotros
          </NavLink>
          <NavLink to="/contacto" className={navClass}>
            Contacto
          </NavLink>
        </nav>

        <div className={styles.aux}>
          {user ? (
            <div className={styles.userBox}>
              {user.photoURL && (
                <img src={user.photoURL} alt="Perfil" className={styles.avatar} />
              )}
              <span className={styles.userName}>
                {user.displayName?.split(" ")[0]}
              </span>
              {isClient && (
                <Link to="/portal" className={styles.adminBadge}>
                  Mi Portal
                </Link>
              )}
              {isAdmin && (
                <Link to="/admin" className={styles.adminBadge}>
                  Admin
                </Link>
              )}
              <button onClick={signOut} className={styles.signout}>
                Salir
              </button>
            </div>
          ) : (
            <Link to="/login" className={styles.signin}>
              Acceder
            </Link>
          )}
        </div>
      </div>
    </header>
  );
}
